import DateDisplay from './DateDisplay'
import Icon from './Icon'
import Spinner from './Spinner'
import { connect } from 'react-redux'
import { KeyCodes } from '../constants/appConstants'
import truncate from 'lodash/truncate'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

const canDeleteComment = (user, comment) => {
  return user && comment.owner && user.id === comment.owner.id
}

const firstLastInitial = user => `${user.firstName} ${user.lastName[0]}.`
const mapStateToProps = (state, ownProps) => ({
  canBeDeleted: canDeleteComment(state.currentUser, ownProps.comment)
})

@connect(mapStateToProps)
class CommentListItem extends Component {
  static propTypes = {
    canBeDeleted: PropTypes.bool.isRequired,
    comment: PropTypes.shape({
      owner: PropTypes.object.isRequired,
      insertDt: PropTypes.string.isRequired,
      commentText: PropTypes.string
    }).isRequired,
    onRemoveClick: PropTypes.func.isRequired
  }

  state = { expanded: false }

  render() {
    const { canBeDeleted, comment, onRemoveClick } = this.props
    const { expanded } = this.state

    return (
      <div className="comment-container">
        <div className="comment-details">
          <span className="comment-author">
            {firstLastInitial(comment.owner)}
          </span>
          <span className="comment-date">
            <DateDisplay date={comment.insertDt} format="MMM D, YYYY h:mma" />
          </span>
        </div>
        {canBeDeleted && (
          <Icon
            name="delete"
            className="right cursor"
            onClick={onRemoveClick}
          />
        )}
        <div className="comment clear-both">
          {expanded
            ? comment.commentText
            : truncate(comment.commentText, {
                length: 90,
                separator: ' '
              })}{' '}
          {comment.commentText.length > 90 && (
            <a onClick={() => this.setState({ expanded: !expanded })}>
              {expanded ? 'less' : 'more'}
            </a>
          )}
        </div>
      </div>
    )
  }
}

export default class CommentList extends Component {
  static propTypes = {
    comments: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onRemove: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  handleKeyUp = e => {
    if (e.which === KeyCodes.ENTER) {
      this.props.onSubmit(e.target.value).then(() => (this.input.value = ''))
    }
  }

  render() {
    const { comments, isLoading, onRemove } = this.props

    return (
      <div>
        {comments.map(comment => (
          <CommentListItem
            key={comment.id}
            comment={comment}
            onRemoveClick={() => onRemove(comment.id)}
          />
        ))}
        <Spinner spinning={isLoading} />
        <div className="new-comment">
          <input
            type="text"
            placeholder={I18n.t('Add a comment')}
            ref={input => (this.input = input)}
            disabled={isLoading}
            onKeyUp={this.handleKeyUp}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/CommentList.js